var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.linkExternal ? "a" : "router-link",
    {
      tag: "component",
      class: _vm.classList,
      attrs: {
        href: _vm.linkExternal ? _vm.url : null,
        to: !_vm.linkExternal ? _vm.url : null,
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("i", { class: _vm.icon }),
          _vm._v(" " + _vm._s(_vm.name) + "\n    "),
          _vm.badge && _vm.badge.text
            ? _c("b-badge", { attrs: { variant: _vm.badge.variant } }, [
                _vm._v("\n      " + _vm._s(_vm.badge.text) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }